import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from './shared/services/auth.service';
import { CommonService } from './shared/services/common.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  userDetails: any;
  parameters: any;
  auth:boolean=false;
  errorMsg: string="";
  successMsg: string="";
  Object = Object;
  res:any[];

  constructor(private authService:AuthService,private commonService:CommonService,private route: ActivatedRoute,private router:Router){

  }
  ngOnInit(): void {
  }
  checkNavListByRole(){
    return this.authService.checkRoleForNavList();
  }
}
